// extracted by mini-css-extract-plugin
export default {"column":"orders__column__ylu4mp","centered":"orders__centered__NXz9YP","endAligned":"orders__endAligned__O8157q","hidden":"orders__hidden__L21a8U"};